import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import MyPlayer from '@/components/myPlayer'
import VideoDemo from '@/components/videoDemo'
import Index from '@/layout/index'
import Login from '@/views/login/index'
import VideoDetail from '@/views/videoDetail/index'
import Order from '@/views/order/index'
import Pay from '@/views/pay/index'
import PayResult from '@/views/payresult/index'
import SelfOrders from '@/views/selforders/index'
import Article from '@/views/article/index'
import FileRule from '@/views/filerule/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/index',
      name: 'MyPlayer',
      component: MyPlayer
    },
    {
      path: '/video',
      name: 'VideoDemo',
      component: VideoDemo
    },
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/videoDetail/:id',
      name: 'VideoDetail',
      component: VideoDetail
    },
    {
      path: '/order/:id',
      name: 'Order',
      component: Order
    },
    {
      path: '/pay/:id',
      name: 'Pay',
      component: Pay
    },
    {
      path: '/payResult',
      name: 'PayResult',
      component: PayResult
    },
    {
      path: '/selfOrders',
      name: 'SelfOrders',
      component: SelfOrders
    },

    {
      path: '/article/:id',
      name: 'Article',
      component: Article
    } ,
    {
      path: '/fileRule',
      name: 'FileRule',
      component: FileRule
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js